import { useSubscription } from '../contexts/SubscriptionContext';
import useAuth from './useAuth';

export const useSubscriptionLimits = () => {
  const { checkLimit, updateUsage, getCurrentPlan } = useSubscription();
  const { userProfile } = useAuth();

  const canPerformAction = async (actionType) => {
    // VAs don't have subscription limits
    if (userProfile?.role !== 'employer') {
      return { allowed: true, remaining: -1 };
    }

    return await checkLimit(actionType);
  };

  const recordAction = async (actionType) => {
    if (userProfile?.role !== 'employer') {
      return { success: true };
    }

    return await updateUsage(actionType);
  };

  const getPlanFeatures = () => {
    const plan = getCurrentPlan();
    return plan?.features || {};
  };

  const hasFeature = (featureName) => {
    const features = getPlanFeatures();
    return features[featureName] === true;
  };

  return {
    canPerformAction,
    recordAction,
    getPlanFeatures,
    hasFeature,
    getCurrentPlan
  };
};